import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// @mui
import { alpha, styled } from '@mui/material/styles';
import {Box, Button} from '@mui/material';
//
import {useEffect, useState} from "react";
import Logo from './Logo';
import ProgressBar from './ProgressBar';
import { useSelector} from "../redux/store";
import {ADMIN_PATH_AFTER_LOGIN, PATH_AFTER_LOGIN} from "../config";
import useAuth from "../hooks/useAuth";
import {DialogAnimate} from "./animate";
import {useSnackbar} from "notistack";
import { useStore } from "react-redux";
import { ADMIN_ROLE_UUID, REGISTER_ROLE_UUID, USER_ROLE_UUID } from 'src/constants/user-role-constants';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
    right: 0,
    bottom: 0,
    zIndex: 999,
    width: '100%',
    height: '100%',
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

SplashScreen.propTypes = {
    isDashboard: PropTypes.bool,
};

export default function SplashScreen({ isDashboard, ...other }) {
    const { googleSignOut } = useAuth();
    const {enqueueSnackbar} = useSnackbar();
    const [openModal, setOpenModal] = useState(false)
    const {isAuthenticated, isInitialized, isRegistered, userRole, email} = useSelector((state) => state.user);
    useEffect(() => {
        if (isAuthenticated && isInitialized && userRole !== "") {
            if(!isRegistered && userRole === REGISTER_ROLE_UUID) {
                //we now accept any valid google accounts
                setTimeout(() => {
                    window.location.href = "/register"
                }, 500)
                
            }
            else if (userRole === ADMIN_ROLE_UUID) {
                setTimeout(() => {
                    window.location.href = ADMIN_PATH_AFTER_LOGIN
                }, 500)

            } else if (userRole === USER_ROLE_UUID){
                setTimeout(() => {
                    window.location.href = PATH_AFTER_LOGIN
                }, 500)
            }
        }
    }, [isRegistered, userRole, isAuthenticated, isAuthenticated]);
    
    // expose store when run in Cypress
    if (window.Cypress) {
        window.store = useStore()
    }

    return (
        <>
            <ProgressBar />
            <DialogAnimate size="md" open={openModal} onClose={() => setOpenModal(false)}>
                <Box sx={{display: "flex", flexDirection: "row", gap: "10px"}}>
                    <span>Please use a gmail e-mail to login to Jobs.</span>
                    <Button onClick={() => {
                        googleSignOut()
                    }} color="error" style={{flex: "1"}}>Remove</Button>
                </Box>
            </DialogAnimate>
            {!isDashboard && (
                <RootStyle {...other}>
                    <m.div
                        animate={{
                            scale: [1, 0.9, 0.9, 1, 1],
                            opacity: [1, 0.48, 0.48, 1, 1],
                        }}
                        transition={{
                            duration: 2,
                            ease: 'easeInOut',
                            repeatDelay: 1,
                            repeat: Infinity,
                        }}
                    >
                        <Logo disabledLink sx={{ width: 64, height: 64 }} />
                    </m.div>

                    <Box
                        component={m.div}
                        animate={{
                            scale: [1.2, 1, 1, 1.2, 1.2],
                            rotate: [270, 0, 0, 270, 270],
                            opacity: [0.25, 1, 1, 1, 0.25],
                            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
                        }}
                        transition={{ ease: 'linear', duration: 3.2, repeat: Infinity }}
                        sx={{
                            width: 100,
                            height: 100,
                            borderRadius: '25%',
                            position: 'absolute',
                            border: (theme) => `solid 3px ${alpha(theme.palette.primary.dark, 0.24)}`,
                        }}
                    />

                    <Box
                        component={m.div}
                        animate={{
                            scale: [1, 1.2, 1.2, 1, 1],
                            rotate: [0, 270, 270, 0, 0],
                            opacity: [1, 0.25, 0.25, 0.25, 1],
                            borderRadius: ['25%', '25%', '50%', '50%', '25%'],
                        }}
                        transition={{
                            ease: 'linear',
                            duration: 3.2,
                            repeat: Infinity,
                        }}
                        sx={{
                            width: 120,
                            height: 120,
                            borderRadius: '25%',
                            position: 'absolute',
                            border: (theme) => `solid 8px ${alpha(theme.palette.primary.dark, 0.24)}`,
                        }}
                    />
                </RootStyle>
            )}
        </>
    );
}
